import { t } from 'i18next'
import React from 'react'
import SuccessScreen from '../MessagesScreens/SuccessScreen';
import successChangePassIcon from '../../assets/success-chnage-pass.svg'
import { useNavigate } from 'react-router-dom'

const ChangePasswordSuccessScreen = () => {
    const navigate = useNavigate();
    return (
        <div className='ps-4 pe-4'>
            <SuccessScreen
                title={t('SUCCESS_SUBMIT_TITTLE')}
                description={t('PASS_CREATED')}
                image={successChangePassIcon}
                buttonTitle={t('GET_INTO')}
                styleImg={{ width: '50px' }}
                onClickButton={() => navigate('/login')}
                withButton
            />
        </div>
    )
}

export default ChangePasswordSuccessScreen